(() => {
  const resourcesCreated = new Set();

  window.Consent = {
    loadScript: (options) => {
      window.Cookies.onChange('consent', (value) => {
        if (!options.url || resourcesCreated.has(options.url)) {
          return;
        }

        if (!options.consent || !value || value.indexOf(options.consent) === -1) {
          return;
        }

        const script = document.createElement('script');
        if (options.onload) {
          script.onload = options.onload;
        }
        script.src = options.url;
        document.head.appendChild(script);
      });
    }
  };
})();
